export default "__VITE_ASSET__a3d6bad9__"